import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import 'parsleyjs';
import { loginUser } from '../../api/auth';
import $ from 'jquery';

const Login = (props) => {

    $(function() {
        document.title = "Sign In";
    });

    const dispatch = useDispatch();

    //Selector
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const [stateReady, setStateReady] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();

        const result = {
            email: $('#email').val(),
            password: $('#password').val(),
        };

        setStateReady(true);
        dispatch(loginUser(result)).then(() => {
            setStateReady(false);
        });
    };

    if(isAuthenticated) {
        props.history.push('/dashboard');
    }

    return (
        <div className="flex items-center h-full justify-center grow bg-center bg-no-repeat page-bg">
            <div className="kt-card max-w-[380px] w-full" style={{marginTop: "10.5%"}}>
                <form
                    id="login"
                    className="kt-card-content flex flex-col gap-5 p-10 parsley-style-1"
                    data-parsley-validate="true"
                    onSubmit={handleSubmit.bind()}>
                    <div className="text-center mb-2.5">
                        <div className="flex items-center justify-center">
                            <img
                                className="h-[120px]"
                                src="assets/media/app/logo.svg"
                                alt="logo"
                            />
                        </div>
                        <span className="text-sm text-secondary-foreground me-1.5 font-medium">Partner Management</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <span className="border-t border-border w-full"></span>
                        <span className="text-xs text-muted-foreground font-medium uppercase">Access</span>
                        <span className="border-t border-border w-full"></span>
                    </div>
                    <div className="flex flex-col gap-1">
                        <label className="kt-form-label font-normal text-mono">
                            Email
                        </label>
                        <input
                            id="email"
                            className="kt-input kt-input-lg"
                            placeholder="email@email.com"
                            type="email"
                            required
                        />
                    </div>
                    <div className="flex flex-col gap-1">
                        <label className="kt-form-label font-normal text-mono">
                            Password
                        </label>
                        <input
                            id="password"
                            className="kt-input kt-input-lg"
                            placeholder="Enter Password"
                            type="password"
                            required
                        />
                    </div>
                    <button className="kt-btn kt-btn-primary kt-btn-lg flex justify-center grow">
                        Sign In
                    </button>
                </form>
            </div>
        </div>
    )
};

export default Login;
